import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, tap } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';

import * as IntegrationsActions from '../actions/integrations.actions';
import { QuickBooksService } from '@app/modules/quick-books/services/quick-books.service';


@Injectable()
export class IntegrationsEffects {

  loadIntegrations$ = createEffect(() => {
    return this._actions.pipe( 

      ofType(IntegrationsActions.loadIntegrations),
      concatMap(() =>

        EMPTY.pipe(
          map(data => IntegrationsActions.loadIntegrationsSuccess({ data })),
          catchError(error => of(IntegrationsActions.loadIntegrationsFailure({ error }))))
      )
    );
  });

  loadQuickBooks$ = createEffect(() => {
    const token = this._quickBooks.refreshToken();
    var data = this._actions.pipe( 
      ofType(IntegrationsActions.loadQuickBooks),
      concatMap(() =>
        this._quickBooks.getRefreshToken(token).pipe(
          map(data => IntegrationsActions.toggleQuickBooks({ active: true })),
          catchError(error => of(IntegrationsActions.toggleQuickBooks({ active: false }))))
      )
    );
    return data;
    /*return this._actions.pipe( 

      ofType(IntegrationsActions.loadQuickBooks),
      concatMap(() =>

        this._quickBooks.getRefreshToken(token).pipe(
          map(data => IntegrationsActions.toggleQuickBooks({ active: true })),
          catchError(error => of(IntegrationsActions.toggleQuickBooks({ active: false }))))
      )
    );*/
  });



  constructor(private _actions: Actions, private _quickBooks: QuickBooksService) {}

}
